import { BottomModal } from "@/components/modals/modals";
import { Merchant } from "@/dto/merchant";
import pom from "@/utils/pom";
import { applyDataTestId } from "@/utils/testUtils";
import { useTranslations } from "next-intl";
import Image from "next/image";
import { useId } from "react";

export interface RunningTabsWelcomeModalProps {
  merchant: Merchant;
  isOpen: boolean;
  onRequestClose: () => void;
}
export const RunningTabsInvalidTableModal = ({
  merchant,
  isOpen,
  onRequestClose,
}: RunningTabsWelcomeModalProps) => {
  const t = useTranslations("RunningTabsInvalidTableModal");
  const merchantLogo = merchant?.logo;
  const titleId = useId();
  const subtitleId = useId();

  return (
    <BottomModal
      overlayClassName="bg-opacity-75"
      onRequestClose={onRequestClose}
      isOpen={isOpen}
      contentClassName="flex flex-col relative bg-white rounded-lg shadow-lg w-full max-w-full h-[92%] sm:h-auto sm:w-auto pt-4 sm:p-4 items-center sm:max-w-[645px]"
      aria={{ labelledby: titleId, describedby: subtitleId }}
    >
      <div
        data-testid={applyDataTestId(pom.scanToOrder.runningTabsWelcomeModal)}
        className="flex px-10 flex-col flex-1 items-center gap-6 pb-4"
      >
        <div
          data-testid={applyDataTestId(
            pom.scanToOrder.runningTabsWelcomeModalHeader
          )}
          className="w-full flex flex-col justify-between items-center gap-6 mt-6"
        >
          {merchantLogo && (
            <Image
              aria-hidden={true}
              className="w-20 h-20"
              src={merchantLogo}
              width={80}
              height={80}
              alt={t("logoAlt")}
            />
          )}
          <h2
            id={titleId}
            aria-describedby={subtitleId}
            className="flex-1 text-2xl justify-center text-center font-semibold text-[#373737]"
          >
            {t("invalidCode")}
          </h2>
        </div>
        <p id={subtitleId} className="text-center">
          {t("speakToStaff")}
        </p>
      </div>
    </BottomModal>
  );
};
